import React from 'react'
import { Field } from 'redux-form'
import { Flag, CurrencyInput, FormLabel, requiredField, numberWithinRange } from '@offerzen/pinata'

import styles from './styles'

const validators = {
  required: requiredField('Required'),
  numberWithinRange: numberWithinRange(10000, 200000, 'Keep in mind this is your preferred monthly cost to company.'),
}

const PreferredSalaryZA = ({ showField, validateField }) => (
  <If condition={showField}>
    <div className={styles.countryFlagWrapper}>
      <Flag countryCode="ZA" className={styles.flag} />
      <FormLabel label="&nbsp;South Africa: Preferred monthly salary (cost to company)" htmlFor="preferred-salary" />
    </div>

    <Field
      name="preferred_salary"
      id="preferred-salary"
      className={styles.currencyInput}
      placeholder="Enter a monthly salary"
      validate={validateField ? validators.required : null}
      warn={validators.numberWithinRange}
      theme="primary"
      component={CurrencyInput}
    />
  </If>
)

export default PreferredSalaryZA
